import type { ComponentProps } from "react"

export default function PropertyOtherResidential(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M29.2706 14.8761C29.26 14.8347 27.0493 8.22275 27.036 8.18275L26.6573 6.66675H24V2.66675H20V6.66675H12V2.66675H7.99997V6.66675H5.32397L4.9453 8.18275L2.7173 14.8494C2.64082 15.1356 2.6311 15.4356 2.6889 15.7262C2.74669 16.0168 2.87045 16.2902 3.05064 16.5254C3.35222 16.814 3.71167 17.0353 4.10518 17.1746C4.49869 17.3139 4.9173 17.368 5.3333 17.3334V29.3334H13.3333V24.0001H18.6666V29.3334H26.6666V17.3334C27.1114 17.407 27.5679 17.3562 27.9856 17.1866C28.4032 17.0169 28.7659 16.735 29.0333 16.3721C29.1712 16.1514 29.2632 15.9052 29.304 15.6482C29.3448 15.3912 29.3334 15.1286 29.2706 14.8761ZM12 22.6667H7.99997V18.6667H12V22.6667ZM24 22.6667H20V18.6667H24V22.6667Z"
        fill={fill}
      />
    </svg>
  )
}
